import React, { useState } from 'react';
import { DialogTitle, DialogContent, DialogActions, Box, Typography, Button, Alert, Stack } from "@mui/material";
import AppDialog from "../../../common/AppDialog";
import { InfoOutlined, GroupAdd } from '@mui/icons-material';
import AssignProjectTeam from '../projects/assignProjectTeam';

function MissingDepartmentsDialog({
    open,
    project,
    onClose,
    onDepartmentsAdded
}) {
    const [showAssignTeam, setShowAssignTeam] = useState(false);

    const handleOpenAssignTeam = () => {
        setShowAssignTeam(true);
    };

    const handleAssignmentSuccess = () => {
        setShowAssignTeam(false);
        if (onDepartmentsAdded) {
            onDepartmentsAdded();
        }
        onClose();
    };

    if (showAssignTeam) {
        return (
            <AppDialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        p: 1
                    }
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Typography variant="h6" fontWeight="700" component="div">
                            Team Assignment
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent dividers sx={{ border: 'none' }}>
                    <AssignProjectTeam
                        project={project}
                        onClose={handleAssignmentSuccess}
                        onTeamAssignSuccess={handleAssignmentSuccess}
                    />
                </DialogContent>
            </AppDialog>
        );
    }

    return (
        <AppDialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                }
            }}
        >
            <DialogTitle sx={{ m: 0, p: 2.5, display: "flex", alignItems: "center", gap: 2 }}>
                <Box sx={{
                    bgcolor: '#fff3cd',
                    p: 1,
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <InfoOutlined sx={{ color: '#ff9800', fontSize: 24 }} />
                </Box>
                <Typography variant="h6" fontWeight="700" component="div">
                    No Departments Assigned
                </Typography>
            </DialogTitle>

            <DialogContent sx={{ pt: 2 }}>
                <Stack spacing={2}>
                    <Alert severity="warning" icon={<InfoOutlined />}>
                        No departments, teams & designations are assigned to this project yet.
                    </Alert>

                    <Typography variant="body2" color="text.secondary">
                        To proceed with creating Epics, Stories, and Tasks, please assign departments and teams to this project first.
                    </Typography>

                    <Box sx={{
                        bgcolor: '#f5f5f5',
                        p: 2,
                        borderRadius: '8px',
                        borderLeft: '4px solid #ff9800'
                    }}>
                        <Typography variant="body2" fontWeight="600" sx={{ mb: 1 }}>
                            Project: <strong>{project?.project_title}</strong>
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Click the button below to assign departments and teams to this project.
                        </Typography>
                    </Box>
                </Stack>
            </DialogContent>

            <DialogActions sx={{ p: 2.5, gap: 1 }}>
                <Button
                    onClick={onClose}
                    variant="outlined"
                    sx={{ textTransform: 'none' }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleOpenAssignTeam}
                    variant="contained"
                    startIcon={<GroupAdd />}
                    sx={{
                        textTransform: 'none',
                        bgcolor: '#6366f1',
                        '&:hover': { bgcolor: '#4f46e5' }
                    }}
                >
                    Assign Team
                </Button>
            </DialogActions>
        </AppDialog>
    );
}

export default MissingDepartmentsDialog;
